import Heading from "components/Heading/Heading";
import NcImage from "components/NcImage/NcImage";
import SebastienCote from "images/SebastienCote.jpg";
import React from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPlayMusicPlayer from "components/ButtonPlayMusicPlayer";
import Image from "components/Image";
import { DEMO_POSTS_AUDIO } from "data/posts";
import iconPlaying from "images/icon-playing.gif";
import { PauseIcon } from "@heroicons/react/24/outline";
import { PlayIcon } from "@heroicons/react/24/solid"
import "../../styles/styles.css"

const SectionFounder = () => {
  const renderIcon = (playing: boolean) => {
    if (playing) 
    {
      return <Image className="w-7" src={iconPlaying} alt="" />;
    }
  }
  const renderButtonPlay = (playing: boolean) => 
    {
    return (
      <Image
        className={` nc-animation-spin rounded-full ${
          playing ? "playing" : ""
        }`}
        src={iconPlaying}
        alt="audio"
      />
    );
  };
  const renderDefaultBtnListen = (state?: "playing") => {
    return (
      <span className="w-11 h-11 flex items-center justify-center rounded-full bg-white dark:bg-neutral-800 text-primary-6000 dark:text-primary-200 shadow-lg cursor-pointer">
        {state === "playing" ? (
          <PauseIcon className="w-6 h-6" />
        ) : (
          <PlayIcon className="w-6 h-6" />
        )}
      </span>
    );
  };
  return (
  <>
    <div className="nowrap nc-SectionFounder relative">
      <Heading desc="Sébastien Côté, directeur général de Visionnaire Drone, fondé en 2019">
        Fondateur
      </Heading>
      <h4></h4>
    </div>
      <div style={{width:"100%"}} className="center">
          <div className="aligne">
            <NcImage
              alt="Fondateur"
              fill
              containerClassName="relative h-0 aspect-h-1 aspect-w-1 rounded-xl overflow-hidden z-0"
              className="absolute inset-0 "
              src={SebastienCote}
            />
            <h3 className="text-lg font-semibold text-neutral-900 mt-4 md:text-xl dark:text-neutral-200">
              {"Sébastien Côté"}
            </h3>
            <span className="block text-sm text-neutral-500 sm:text-base dark:text-neutral-400">
              {"Directeur général"}
            </span>
          </div>
          <div style={{marginLeft:"50px"}} className="aligne">
            <ButtonPlayMusicPlayer
            renderChildren={renderButtonPlay}
            post={DEMO_POSTS_AUDIO[0]}
            renderDefaultBtn={() => renderDefaultBtnListen()}
            renderPlayingBtn={() => renderDefaultBtnListen("playing")}
          />
          
          </div>
          
      </div>
    </>
  );
};

export default SectionFounder;
